// host-redirect.js — self-healing URL rewrite (Explorer copy).
//
// Hanko's session cookie is scoped to .samsurveyor.com. If Console opens
// Explorer at the legacy cloudsam-survey-explorer-*.run.app URL (because
// its sysconfig hasn't been re-pointed yet, or a stale tab is in play),
// the cookie isn't accessible and every /me call 401s. Rewrite the
// location to the canonical samsurveyor.com host before React mounts.
//
// Import this as the FIRST thing in index.js so the rewrite runs before
// any Hanko code has a chance to fire. No-op on samsurveyor.com / localhost.

try {
    const loc = (typeof window !== 'undefined') ? window.location : null;
    if (loc && /\.run\.app$/i.test(loc.hostname)) {
        const target = `https://explorer.samsurveyor.com${loc.pathname}${loc.search}${loc.hash}`;
        loc.replace(target);
    }
} catch (_) {
    // Best-effort — fall through to normal boot if anything goes wrong.
}
